import { render, staticRenderFns } from "./MT5AutoSyncCTA.vue?vue&type=template&id=cc7651ea&scoped=true"
import script from "./MT5AutoSyncCTA.vue?vue&type=script&lang=js"
export * from "./MT5AutoSyncCTA.vue?vue&type=script&lang=js"
import style0 from "./MT5AutoSyncCTA.vue?vue&type=style&index=0&id=cc7651ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7651ea",
  null
  
)

export default component.exports